export default __webpack_public_path__ + "static/media/@pedrohenrique_souza76.6d3e8635.PNG";